/**
 * Alpine component on the proposal composer's form. It keeps Send off while the body
 * has no link to the proposal. The server refuses such a send as well; this only says
 * so sooner, so it follows MergeTags.link_tag?: a chip, or a plain tag in the text.
 */
const PLAIN_TAG = /\{\{\s*proposal\.(?:link|url)\s*\}\}/;
const CHIP = /<span\b[^>]*\bdata-proposal-tag=(["'])(?:link|url)\1/i;

export function bodyHasLink(html) {
  const body = String(html ?? "");
  // A marker instead of nothing, so a tag split across two elements stays split.
  return CHIP.test(body) || PLAIN_TAG.test(body.replace(/<[^>]*>/g, "\u0000"));
}

export function proposalComposerData({ linkChip = "", mergeTags = [] } = {}) {
  return {
    hasLink: true,
    mergeTags,

    init() {
      this.refresh();
      // Fired on the editor itself, and it emits no tiptap:update.
      this.editorRoot()?.addEventListener("tiptap:set-content", () => this.$nextTick(() => this.refresh()));
    },

    onEditorChange(html) {
      this.hasLink = bodyHasLink(html);
    },

    refresh() {
      this.onEditorChange(this.form()?.querySelector("input[name='body_html']")?.value);
    },

    onSubmit(event) {
      this.refresh();
      if (!this.hasLink) event.preventDefault();
    },

    // Turbo disables Send for the request, which drops its focus out of the dialog.
    onSubmitEnd(event) {
      if (event.detail.success) return;
      const form = this.form();
      if (!form.contains(document.activeElement)) form.querySelector("button[type='submit']")?.focus();
    },

    addLink() {
      this.insert(linkChip);
    },

    // Values go in as a text node, so nothing in them can read as markup.
    insertTag(tag) {
      this.insert(tag.html ?? { type: "text", text: tag.text });
    },

    insert(content) {
      this.editorRoot()?.dispatchEvent(
        new CustomEvent("tiptap:insert-content", { detail: { content, proposalTag: true } })
      );
    },

    form() {
      return this.$el.closest("form");
    },

    editorRoot() {
      return this.form()?.querySelector("[x-data^='tiptapEditor']");
    }
  };
}

export default function registerProposalComposer(Alpine) {
  Alpine.data("proposalComposer", proposalComposerData);
}
